import Vue from 'vue'
import App from './App.vue'
import VuePageTransition from './components/transition'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import firebaseServices from './_services/firebase'
//import firebase from 'firebase/compat/app';

import VueYoutube from 'vue-youtube'

import vueVimeoPlayer from 'vue-vimeo-player'
import Vuelidate from 'vuelidate'
//import VueGtag from "vue-gtag";
//Vue.use(VueGtag, {
  //config: { id: "UA-1234567-1" }
//});
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import style (<= Swiper 5.x)
import 'swiper/css/swiper.css'
import "firebase/firestore";
import store from "./state/store";


// Initialize Firebase
/*
var authFirebaseConfig={
  apiKey: "AIzaSyAYj0WTCBQkIMRUfEto7g_JuXKVsRZricE",
  authDomain: "heart-of-house-educationworlds.firebaseapp.com",
  projectId: "heart-of-house-educationworlds",
  storageBucket: "heart-of-house-educationworlds.appspot.com",
  messagingSenderId: "62287572432",
  appId: "1:62287572432:web:b1f4dfd89fa12d28ff1dd5",
  measurementId: "G-QHGBKCZ5EK",
  dataBaseUrl:"https://heart-of-house-educationworlds.firebaseio.com"
}
*/
/*
const shipandDashConfig = {
  apiKey: "AIzaSyDvmJUq6bNntA0zLDBivweCyAeL6OFc9Z8",
  authDomain: "sawdc-ship-and-dash.firebaseapp.com",
  projectId: "sawdc-ship-and-dash",
  storageBucket: "sawdc-ship-and-dash.appspot.com",
  messagingSenderId: "643329741056",
  appId: "1:643329741056:web:8ddc135a61df5960e063e5",
  measurementId: "G-MDGLDZ0JRH"
};*/
/* 
const westDashConfig={
  apiKey: "AIzaSyAqe7-N-kR68avKyjccgzB36RI45tme1dM",
  authDomain: "west-ship-and-dash.firebaseapp.com",
  projectId: "west-ship-and-dash",
  storageBucket: "west-ship-and-dash.appspot.com",
  messagingSenderId: "47012209108",
  appId: "1:47012209108:web:cd6f3ffe1889909395f641",
  measurementId: "G-Y5KE24EYXW"

}*/

const JOCOWORKSConfig = {
  apiKey: "AIzaSyCZX7HmcKFeZajIJ4X_c3yB4gygwaW2cqo",
  authDomain: "nctejw-dash-slingshot.firebaseapp.com",
  projectId: "nctejw-dash-slingshot",
  storageBucket: "nctejw-dash-slingshot.appspot.com",
  messagingSenderId: "356852539564",
  appId: "1:356852539564:web:a1a2629e9acc4b6c1f7f09",
  measurementId: "G-Q5WTHNN8KN"
};

// var firebaseConfig = {
//   apiKey: "AIzaSyCzbBNbbGEZCxSKcODTOe5_Yh_dORvbKUI",
//   authDomain: "testinganalytics-2a9eb.firebaseapp.com",
//   projectId: "testinganalytics-2a9eb",
//   storageBucket: "testinganalytics-2a9eb.appspot.com",
//   messagingSenderId: "893282383009",
//   appId: "1:893282383009:web:8af7577e1c6c504c1dace0",
//   measurementId: "G-149XWXM70W"
//  };
// Initialize Firebase
//firebase.initializeApp(firebaseConfig);
//firebase.analytics(

  firebaseServices.fBInit(JOCOWORKSConfig)

Vue.prototype.$fb = firebaseServices
store.$fb = firebaseServices

console.log(store.$fb)
  // Tell the application what to do when the
  // authentication state has changed
  firebaseServices.auth().onAuthStateChanged(
    (user) => {
      firebaseServices.handleOnAuthStateChanged(store, user)
    },
    (error) => {
      console.error(error)
    }
  )
  //const analytics = firebase.analytics();
  //console.log(analytics)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)

Vue.use(VueAwesomeSwiper, 
  /* { default options with global component } */)
  Vue.use(VueYoutube)
  Vue.use(vueVimeoPlayer)
//import router from './_router/mouter';
//port { TweenMax, TimelineLite, EasePack, Draggable } from "gsap";

import router from './router'
//firebase.initializeApp(firebaseConfig);
//const analytics = firebase.analytics();
//console.log(analytics)

//Vue.config.productionTip = false
Vue.use(VuePageTransition )
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
 

new Vue({
  store:store,
  router,
  render: h => h(App),

}).$mount('#app')